import axios from 'axios'
import config from '../config'

export default {
  request (method, uri, data = null, debug = null) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }
    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }
    var url = config.serverURI + uri
    var jwt = window.localStorage.getItem('token')
    var headers
    if (jwt) {
      headers = {
        'Content-Type': 'text/plain',
        'X-Authorization': jwt
      }
    } else {
      headers = {
        'Content-Type': 'text/plain'
        // 'Accept-Encoding': 'gzip, compress'
      }
    }
    return axios({
      method: method,
      url: url,
      data: data,
      headers: headers
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js